import React, { useContext, useState } from 'react'
import { CoreContext } from 'context/CoreContext'
import useI18n from 'hooks/useI18n'
import Button from 'components/Form/Button'
import Wrapper from '../Wrapper'
import {
    ModalActions,
    NotificationBullet,
    NotificationList,
    NotificationSurface,
    NotificationText,
} from './styled'

export default function ModalWebNotification() {
    const { modal } = useContext(CoreContext)
    const { t } = useI18n()
    const [loading, setLoading] = useState(false)

    const handleEnable = async () => {
        if (typeof modal?.onEnable !== 'function') return

        setLoading(true)
        try {
            await modal.onEnable()
        } finally {
            setLoading(false)
        }
    }

    const handleDismiss = () => {
        if (typeof modal?.onDismiss === 'function') {
            modal.onDismiss()
        }
    }

    return (
        <Wrapper
            title={t('web_notifications_title') || 'Enable notifications'}
            text={t('web_notifications_description') || 'Receive course updates, support replies, and new activity without keeping the platform open.'}
            onClose={handleDismiss}
        >
            <NotificationSurface>
                <NotificationText>
                    {t('web_notifications_body') || 'Turn on browser notifications to stay on top of new content, replies, and platform activity.'}
                </NotificationText>

                <NotificationList>
                    <NotificationBullet>{t('web_notifications_bullet_updates') || 'New content and course releases'}</NotificationBullet>
                    <NotificationBullet>{t('web_notifications_bullet_support') || 'Support ticket updates and replies'}</NotificationBullet>
                    <NotificationBullet>{t('web_notifications_bullet_reminders') || 'Important reminders while you are away from the tab'}</NotificationBullet>
                </NotificationList>
            </NotificationSurface>

            <ModalActions>
                <Button onClick={handleDismiss} width="160px" outline color="primary" small nospace>
                    {t('web_notifications_later') || 'Maybe later'}
                </Button>
                <Button color="blue" loading={loading} onClick={handleEnable} width="220px" small nospace>
                    {t('web_notifications_enable') || 'Enable notifications'}
                </Button>
            </ModalActions>
        </Wrapper>
    )
}
